// Anchor.js

import React, { useState } from "react";

const Anchor = ({text,onPress,mapAddress,phoneNumber,href,force=false,nativeID,testID,style,textStyle,hoverStyle,...props})=>{
  if (!!force || (href?.substring(0,4)==="http" && typeof(onPress)!=="function")) {
    props.target = "_blank";
  }
  if (!text && !props.children && !!href) {
    text = href;
  }
  if (!!nativeID) {
    props.id = nativeID;
  }
  if (!!mapAddress) {
      href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapAddress)}`;
  }
  if (!!phoneNumber) {
      href = `tel:+1${phoneNumber.replace(/\D/g,"")}`;
  }
  const _onPress = (e)=>{
    if (!!phoneNumber) {
      return true;
    }
    if (e.metaKey||e.ctrlKey) {
      // window.open(href, '_blank');  // CTRL-CLICK to open in new tab is happening natively. Something was fixed in here and now this 'window.open' was causing a second tab to open!
      // Cancel any other actions in this window.
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    if (!force) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (typeof(onPress)==="function") {
      onPress();
    } else if (!!href) {
      if (href.substring(0,4)==="http") {
        window.open(href, '_blank');
      } else {
        window.main.lib.setCurrentView(href);
      }
    }
  };
  const [hoverState,hoverSetState] = useState(false);
  const _onMouseEnter = ()=>{ hoverSetState(true); };
  const _onMouseLeave = ()=>{ hoverSetState(false); };
  const __style = {color:window.main.theme.colors[(!!hoverState?"base":"baseDark")],textDecoration:"none",...style,...textStyle,...(!!hoverState&&!!hoverStyle?hoverStyle:{})};
  if (typeof(onPress)==="function") {
    return (
      <a
      onClick={_onPress}
      data-testid={testID}
      style={__style}
      onMouseOver={_onMouseEnter}
      onMouseOut={_onMouseLeave}
      {...props}>
        {props.children || text}
      </a>
    );
  } else {
    return (
      <a href={href||"#notimplemented"} onClick={_onPress} data-testid={testID} style={__style} onMouseEnter={_onMouseEnter} onMouseLeave={_onMouseLeave} {...props}>
        {props.children || text}
      </a>
    );
  }
}

export default Anchor;
